import * as React from 'react';
import  { withStyles } from '@mui/styles';

import { WithStyles, StyleRules, ClassNameMap } from '@mui/styles/withStyles';


import { IconButton } from '@mui/material';
import { Menu, MenuItem } from '@mui/material';
// import { ExpandMore, ExpandLess } from '@mui/icons-material';
import { Divider, Tooltip } from '@mui/material';
var Mousetrap = require("mousetrap")
import { Theme } from '@mui/styles';
import * as request from 'superagent';
import { APIError } from '../../lib/types';
// import ConfirmActionModal from '../../../payables/components/modal/confirm-action-modal'
import ProxySelectModal from '~common/components/proxy-select'

import portalUserContext from '~common/lib/portal-user-context';
import ErrorView from '~common/components/error-view';
import classNames from 'classnames';

import translate from '../i18n/i18n'



Mousetrap.prototype.stopCallback = function (e, element) {
  e.preventDefault()
  return false
}


const styles = (theme: Theme): StyleRules => ({
  root: {
    textAlign: 'unset',
    paddingTop: 75,
    paddingLeft: 15,
    paddingRight: 15
    //background: "black url(https://static.boydgaming.net/boydgaming/assets/shell/background.jpg) top no-repeat;",
  },
  toolbar: {
    '@media only print': { display: 'none' }
  },
  flex: {
    flex: 1
  },
  appTitle: {
    flex: 1,
    color: '#fff',
    marginTop: 5,
    fontFamily: 'Arial,san-serif,Helvetica,Trebuchet MS'
  },
  drawerList: {
    width: 250
  },
  menuButton: {
    color: "white",
    marginLeft: -12,
    marginRight: 20
  },
  userPrefButton: {
    color: "white",
    marginLeft: -12,
    marginRight: 20
  },
  logo: {
    marginTop: 0,
    height: 40,
    width: 'auto'
  },
  bottomPadding: {
    height: 60
  },
  chip: {
    margin: theme.spacing()
  },
  homeIcon: {
    marginRight: 10
  },
  nested: {
    paddingLeft: theme.spacing(2),
  },
  appBarButton:{}
})

interface Props extends React.HTMLProps<HTMLDivElement> {
  history: any
  color?: any
};

type State = {
  anchorEl?: HTMLElement
  showProxies: boolean;
  error?: APIError;
  showModal?: string;
};

class View extends React.Component<Props & WithStyles<keyof typeof styles>, State> {
  constructor(props: Props & WithStyles<keyof typeof styles>) {
    super(props, {})
    this.state = {
      showProxies: false
    };
  }

 componentDidMount() {
    if (!portalUserContext.isProxy) {
      Mousetrap.bind("ctrl+alt+p", this.handleNavigation('/preferences'))
      Mousetrap.bind("ctrl+alt+l", this.handleNavigation('/logout'))
    }
  }

  // UNSAFE_componentWillReceiveProps(newProps: Props & WithStyles<keyof typeof styles>) {
  // }

  handleAccountMenu = (event: any) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleRequestClose = () => {
    this.setState({
      anchorEl: undefined
    });
  };


  handleNavigation = (url: string) => () => {
    window.location.href = url
  };

  toggleProxies = () => {
    this.setState({
      showProxies: !this.state.showProxies
    })
  }

  confirmProxySelection = (p: any) => () => {
    this.setState({
      showModal: "confirmProxySelection"
    })
  }

  closeModal = () => {
    this.setState({
      showModal: undefined
    })
  }

  selectProxy = () => {
    // request.post(`/api/portal-user-proxy/${this.state.confirmProxySelectionID}/start`).then((response: request.Response)=>{
    // 	if (!response.ok) {
    // 		const apiErr = new APIError()
    // 		apiErr.type = "api"
    // 		apiErr.message = "Error Saving Proxies"
    // 		apiErr.details = response.body.toString()
    // 		this.setState({
    // 			error: apiErr
    // 		})
    // 	} else {
    // 		console.log("proxy response", response.body)
    // 		window.location.href = "/"
    // 		window.location.reload()
    // 	}
    // }).catch((err)=>{
    // 	console.error(err)
    // 	const apiErr = new APIError()
    // 	apiErr.type = "http"
    // 	apiErr.message = "Error fetching data"
    // 	apiErr.details = (err.response || {text: err.toString()}).text
    // 	this.setState({
    // 		error: apiErr
    // 	})
    // })
  }

  endProxy = () => {
    // console.log("endProxy")
    request.post(`/api/portal-user-proxy/${portalUserContext.userContext.id}/stop`).then((response: request.Response) => {
      if (!response.ok) {
        const apiErr = new APIError()
        apiErr.type = "api"
        apiErr.message = "Error Starting Proxy Session"
        apiErr.details = response.body.toString()
        this.setState({
          error: apiErr
        })
      } else {
        window.location.href = "/"
      }
    }).catch((err) => {
      console.error(err)
      const apiErr = new APIError()
      apiErr.type = "http"
      apiErr.message = "Error Starting Proxy Session"
      apiErr.details = (err.response || { text: err.toString() }).text
      this.setState({
        error: apiErr
      })
    })
  }

  onErrorViewClose = () => {
    this.setState({
      error: undefined
    })
  }

  openProxyModal = () => {
    this.setState({
      showModal: "confirmProxySelection"
    })
  }

  render() {

    const { classes }: { classes: ClassNameMap; } = this.props;

    const { anchorEl, error } = this.state;
    const open = Boolean(anchorEl);

    var proxies = Array<any>();
    if ((window as any).App.userContext.extendedAttributes && (window as any).App.userContext.extendedAttributes.proxyOptions) {
      proxies = (window as any).App.userContext.extendedAttributes.proxyOptions
    }
    var modal
    if (this.state.showModal == "confirmProxySelection") {
      modal = <ProxySelectModal open={true} proxyOptions={proxies} handleClose={this.closeModal}></ProxySelectModal>
      // modal = <ConfirmActionModal confirmAction={{title: "Proxy Selection", description: `Are you sure you want to begin a proxy session acting as ${this.state.confirmProxySelectionFullName}?`, options: {}}} handleDispatch={this.selectProxy} open={true} handleClose={this.closeModal}  classes={{}}></ConfirmActionModal>
    }

    var errorView;
    if (error) {
      errorView = <ErrorView classes={{}} error={error} onClose={this.onErrorViewClose} />;
    }

    // console.log("this.state", this.state)

    // console.log("user prefs core", portalUserContext.isProxy)

    return (
      <div style={{ position: 'relative' }}>
        {errorView}
        {modal}
        <IconButton
          size="large"
          color="primary"
          className={classNames(classes.userPrefButton, classes.menuButton)}
          aria-owns={open ? 'menu-appbar' : undefined}
          aria-haspopup="true"
          onClick={this.handleAccountMenu}
        >
          <i style={{color: portalUserContext.isProxy ? '#2dc62c' : 'primary'}} className={portalUserContext.isProxy ? "fas fa-user-friends" : "fas fa-user"}></i>
        </IconButton>
        <Menu
          id="menu-appbar"
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          open={open}
          onClose={this.handleRequestClose}
        >

          {portalUserContext.isProxy && <Tooltip title="Ctrl+Alt+P" enterDelay={500}>
            <MenuItem disabled={true}>{portalUserContext.userContext.displayName}</MenuItem>
          </Tooltip>}

          {!portalUserContext.isProxy && <Tooltip title="Ctrl+Alt+P" enterDelay={500}>
            <MenuItem onClick={this.handleNavigation('/preferences')}>{translate("Preferences")}</MenuItem>
          </Tooltip>}

          {proxies.length > 0 && <MenuItem onClick={this.openProxyModal}>Start Proxy Session</MenuItem>}

          {/* {proxies.length > 0 && <MenuItem onClick={this.toggleProxies}>Proxies{this.state.showProxies ? <ExpandLess style={{marginLeft: 15}} /> : <ExpandMore style={{marginLeft: 15}} />}</MenuItem>} */}

          {/* <Collapse in={this.state.showProxies} timeout="auto" unmountOnExit>
				{proxies.map((p: any, idx)=>{
					return (
						<MenuItem key={idx} onClick={this.confirmProxySelection(p)} className={classes.nested}>{p.userFullName}</MenuItem>
					)
				})}
			</Collapse> */}

          {!portalUserContext.isProxy && <Divider></Divider>}
          {!portalUserContext.isProxy && <Tooltip title="Ctrl+Alt+L" enterDelay={500}>
            <MenuItem onClick={this.handleNavigation('/logout')}>{translate("Logout")}</MenuItem>
          </Tooltip>}

          {portalUserContext.isProxy && <MenuItem onClick={this.endProxy}>End Proxy Session</MenuItem>}
        </Menu>
      </div>
    );
  }
}

export default withStyles(styles)(View);


